// mutations.js

export default {
    updateRulesList(state, brands){
        state.rulesList = brands
    },
    updateDeviceInfo(state, { id, info }){
        state.devicesInfo[id] = info
    },
    updateSelectedDeviceRules(state, rules){
        state.selectedDeviceRules = rules
    }
};
